/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Bo as Bo,
  rec_Componente_Qk_81_107 as Componente_Qk_81_107,
  rec_Componente_Zk_90_107 as Componente_Zk_90_107,
  rec_EstadoError as EstadoError,
  rec_FormularioFundo as FormularioFundo,
  rec_Go as Go,
  rec_JSXRuntime as JSXRuntime,
  rec_Nk as Nk,
  rec_React as React,
  rec_Ti as Ti,
  rec_api as api,
  rec_ii as ii,
  rec_wi as wi,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function Fundos() {
  let e = Go(),
    [t, n] = (0, React.useState)([]),
    [r, i] = (0, React.useState)(!0),
    [a, o] = (0, React.useState)(``),
    [s, c] = (0, React.useState)(null),
    [l, u] = (0, React.useState)(!1),
    f = (0, React.useCallback)(async () => {
      i(!0);
      try {
        (n(await api(`/fundos?todos=true`)), o(``));
      } catch (e) {
        o(e.message);
      } finally {
        i(!1);
      }
    }, []);
  (0, React.useEffect)(() => {
    f();
  }, [f]);
  async function p() {
    if (!l) {
      (u(!0), o(``));
      try {
        let t = await api(`/fundos/sincronizar`, {
          method: `POST`,
        });
        (e.ok(Nk(t)), await f());
      } catch (e) {
        o(e.message);
      } finally {
        u(!1);
      }
    }
  }
  async function m(e) {
    try {
      (await api(`/fundos/${e.id}`, {
        method: `PUT`,
        body: JSON.stringify({
          nombre: e.nombre,
          activo: !e.activo,
          sedeId: e.sedeId,
        }),
      }),
        f());
    } catch (e) {
      o(e.message);
    }
  }
  return (
    <div
      className={`flex flex-col gap-3`}
      children={[
        <EstadoError mensaje={a} onReintentar={f} />,
        <div
          className={`flex flex-wrap justify-end gap-2`}
          children={[
            <button
              type={`button`}
              onClick={p}
              disabled={l}
              className={zo}
              children={[
                l &&
                  (0, JSXRuntime.jsx)(ii, {
                    className: `mr-1 inline h-3.5 w-3.5 animate-spin`,
                  }),
                `Sincronizar con Transporte`,
              ]}
            />,
            <button
              type={`button`}
              onClick={() => c({})}
              className={zo}
              children={[
                <Ti className={`mr-1 inline h-3.5 w-3.5`} />,
                ` Nuevo fundo`,
              ]}
            />,
          ]}
        />,
        r ? (
          <Componente_Zk_90_107 />
        ) : t.length === 0 ? (
          <Componente_Qk_81_107
            texto={`Todavía no hay fundos. Sincronizá con Transporte o cargá el primero.`}
          />
        ) : (
          <ul
            className={`flex flex-col gap-2`}
            children={t.map((e) => (
              <li
                key={e.id}
                className={`${Bo} flex items-center gap-3`}
                children={[
                  <span
                    className={`flex-1 text-sm text-(--text-h)`}
                    children={[e.nombre, e.sedeNombre && <span className={`ml-2 rounded-full bg-(--panel) px-2 py-0.5 text-[10px] text-(--text)`} children={e.sedeNombre} />]}
                  />,
                  !e.activo && (
                    <span
                      className={`rounded-full bg-(--panel) px-2 py-0.5 text-[10px] uppercase text-(--text)`}
                      children={`inactivo`}
                    />
                  ),
                  <button
                    type={`button`}
                    onClick={() =>
                      c({
                        editar: e,
                      })
                    }
                    aria-label={`Editar ${e.nombre}`}
                    className={`rounded-lg p-2 text-(--text) hover:bg-(--accent-bg) hover:text-(--accent)`}
                    children={(0, JSXRuntime.jsx)(wi, {
                      className: `h-3.5 w-3.5`,
                    })}
                  />,
                  <button
                    type={`button`}
                    onClick={() => m(e)}
                    className={`rounded-lg px-2 py-2 text-xs text-(--text) hover:bg-(--accent-bg) hover:text-(--accent)`}
                    children={e.activo ? `Desactivar` : `Activar`}
                  />,
                ]}
              />
            ))}
          />
        ),
        s && (
          <FormularioFundo
            editar={s.editar}
            onClose={() => c(null)}
            onGuardado={() => {
              (c(null), f());
            }}
          />
        ),
      ]}
    />
  );
}
